<template>
  <div
      class="client-order mt-3 active"
      data-displ="first"
      v-if="this.chosenServices.length > 0"
  >
    <div
        class="order-header px-3 py-2"
        :class="{
                'header-inprogress': this.order.status == 'inprogress',
                'header-ready': this.order.status == 'ready',
                'header-paymentpending': this.order.status == 'paymentpending'
            }"
    >
      <v-col col="12" class="d-flex">
        <h5 class="ma-auto">Заказ {{ this.showOrderInfo() }}</h5>
        <v-spacer></v-spacer>
        <v-icon
            v-if="!addServiceDisabled"
            @click="removeAllItemFromCart"
        >
          mdi-trash-can
        </v-icon>
      </v-col>
    </div>
    <div class="order-body px-4 py-2">
      <template class="order-single" v-for="(service, index) in cart.services">
        <v-row :key="'catServ-' + index">
          <v-col class="ma-1">
            <div class="order-name-price">
              <div class="row d-block">
                <div class="d-flex justify-content-between">
                  <h5 class="ma-0 font-weight-light" style="font-size:18px!important; line-height: 1.3rem;">
                    {{ service.title }}
                    {{ getServiceType(service) ? `(${getServiceType(service)})` : '' }}
                  </h5>
                  <template v-if="!addServiceDisabled">
                                <span
                                    class="text-danger"
                                    role="button"
                                    @click.prevent="removeItemFromCart(index)"
                                >X</span
                                >
                  </template>
                </div>
                <h4
                    class="small mb-0"
                    v-if="service.params && service.params.description"
                >
                  <template v-if="wheelSide[index]">[{{ wheelSide[index] }}] </template>
                  {{
                    service.params ? service.params.description : ""
                  }}
                </h4>
                <div class="d-flex justify-content-between">
                  <h4 class="single-order-type mb-0">
                    <template v-if="!addServiceDisabled">
                      <v-btn
                          v-if="service.manual_discount"
                          small
                          icon
                          color="green"
                          @click.prevent="editItemPrice(index)"
                      >
                        <v-icon
                            class="mx-1"
                        >mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    {{
                      service.price
                          ? numberWithSpaces(
                              Math.floor(service.price, 2)
                          )
                          : 0
                    }}₽ * {{ service.quantity }}
                  </h4>
                  <h4 class="single-order-type mb-0">
                    ={{
                      service.price
                          ? numberWithSpaces(
                              Math.floor(
                                  service.price *
                                  service.quantity,
                                  2
                              )
                          )
                          : 0
                    }}
                    ₽
                  </h4>
                </div>
                <template v-if="service.discountable">
                  <h4 class="small mb-0">
                    Скидка составила
                    {{
                      Math.floor(
                          service.discountAmount *
                          service.quantity,
                          2
                      )
                    }}₽
                  </h4>
                </template>
                <template v-else>
                  <h4 class="small mb-0">
                    Скидка на услугу не действует
                  </h4>
                </template>
              </div>
            </div>
            <div class="single-order-additional mt-2">
              <div class="order-additional"></div>
            </div>
          </v-col>
        </v-row>
      </template>
    </div>
    <div class="order-footer p-3 align-items-center flex-wrap">
      <p>
        <b>Итого: {{ cart.sum ? numberWithSpaces(cart.sum) : 0 }}₽</b
        ><br />
        <small>
          Сумма заказа расчитана {{ cart.discountType }}
          <template v-if="cart.minimalPricesFlag">
            <br />
            В расчете суммы заказа применены
            минимально-возможные цены на услуги.
          </template>
        </small>
      </p>
      <div class="row">
        <template v-if="!order.status || order.status === 'pending'">
          <button
              class="btn mr-auto put-off enable"
              @click="showOrderRecModal()"
              data-test-id="openSaveModalButton"
          >
            Записать <br />
            <i>Отложить</i>
          </button>
          <v-btn
              class="btn ml-auto on-work red"
              :loading="stateInProgress"
              height="52"
              data-test-id="buttonInWork"
              @click="openAvailableEmployeesModal('inprogress')"
          >
            В работу
          </v-btn>
        </template>
        <template v-if="order.status && order.status !== 'pending'">
          <button
              class="btn mr-auto put-off enable"
              v-if="order.status != 'inprogress'"
              @click="rollbackOrderStatus()"
          >
            Назад
          </button>
          <v-btn
              v-if="order.status === 'inprogress'"
              class="ml-auto on-work mr-2 mb-2 font-normal"
              data-test-id="orderIsEnd"
              @click="[checkTighten(), checkOrderQA()]"
          >
            Готов
          </v-btn>
          <button
              v-if="order.status == 'ready'"
              class="btn ml-auto on-work"
              data-test-id="orderGetMoney"
              @click="sendOrderToBackend('paymentpending')"
              :disabled="order.stateInProgress"
          >
            Принять оплату
          </button>
          <button
              v-if="order.status == 'paymentpending'"
              class="btn ml-auto on-work"
              @click="showPaymentModal()"
              :disabled="order.stateInProgress"
          >
            Принять оплату
          </button>
        </template>
      </div>
      <div
          v-if="(order.status == 'ready' || order.status == 'paymentpending') && haveRecs"
          class="mt-6">
        <v-btn
            outlined
            @click="addRecommends"
            block
        >{{ recommendations ? 'обновить' : 'добавить' }} рекомендации</v-btn>
      </div>
      <v-list
          v-if="(order.status == 'ready' || order.status == 'paymentpending') && haveRecs && recommendations"
          class="text-left order-body"
          max-height="150"
          dense
      >
        <template v-for="(rec, indx) in recommendations">
          <v-list-item :key="'reclist-' + indx">
            <v-list-item-content>
              <v-list-item-title>{{rec.title}}</v-list-item-title>
              <v-list-item-subtitle>{{rec.content}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

      </v-list>
      <time-bar
          v-if="orderInfo.time"
          :time="orderInfo.time"
      />
    </div>
    <choose-employees-modal
        :order="true"
        :shiftId="shiftData.id"
        @clicked="onEmployeeChoosed"
        :style="{ 'z-index': 1100 }"
    ></choose-employees-modal>
    <modal name="editPriceModal" height="auto">
      <div
          class="modal-content"
          v-if="cart.services && chosenServicesEditIndex"
      >
        <div class="modal-header">
          <h5 class="modal-title p-4 d-inline-block">
            {{ chosenServicesTitle }}
          </h5>
          <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$modal.hide('editPriceModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-row align-items-center">
              <div class="col-auto mx-auto">
                <label for="inlineFormInput">Цена:</label>
                <v-text-field
                    v-model="chosenServicesPrice"
                    outlined
                    type="number"
                    :rules="rulePrice"
                    dense
                ></v-text-field>
              </div>
              <div class="col-auto mx-auto">
                <label for="inlineFormInputGroup"
                >Количество:</label
                >
                <v-text-field
                    v-model="chosenServicesQuantity"
                    outlined
                    type="number"
                    :rules="ruleQuantity"
                    clearable
                    dense
                ></v-text-field>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
              type="button"
              class="btn btn-outline-dark btn-sm"
              @click.prevent="$modal.hide('editPriceModal')"
          >
            Отмена
          </button>
          <button
              type="button"
              class="btn btn-success btn-sm"
              @click.prevent="
                            closeEditItemPrice(chosenServicesEditIndex - 1)
                        "
              :disabled="!checkFilds"
          >
            Изменить
          </button>
        </div>
      </div>
    </modal>
    <modal name="orderRecModal" width="700px" height="550px">
      <div class="row justify-content-center">
        <h5 class="modal-title p-4 d-inline-block">
          Расчет стоимости заказа на
          {{ numberWithSpaces(this.cart.sum) }}₽
        </h5>
      </div>
      <div class="modal-body">
        <div
            class="flex align-items-center justify-content-center px-4 py-0 flex-wrap"
        >
          <v-col md="auto" col="4">
            <v-text-field
                v-model="storePhone"
                v-mask="'+7(###) ###-##-##'"
                label="Телефон клиента"
                name="phoneNumber"
                :rules="phoneNumber"
                autocomplete="off"
                required
                data-test-id="saveModalPhone"
            />
          </v-col>
          <v-col md="auto" col="4">
            <v-text-field
                v-model="storeName"
                label="Имя клиента"
                name="clientName"
                :rules="clientName"
                autocomplete="off"
                required
                data-test-id="saveModalName"
            />
          </v-col>
        </div>
        <div
            class="flex align-items-center justify-content-center px-4 py-2 flex-wrap"
        >
          <div class="pay-method visa col">
            <div>
              <a
                  href=""
                  data-test-id="recommendationOrder"
                  class="pay-visa next"
                  @click.prevent="
                                    [
                                        openAvailableEmployeesModal(
                                            'recomendation'
                                        ),
                                        hideOrderRecModal(),
                                        showThankYouModal()
                                    ]
                                "
              >
                <img
                    src="images/services/onwork/print.png"
                    alt=""
                />
                <h4 class="on-work-button-title">
                  Рекомендация
                </h4>
              </a>
            </div>
          </div>
          <div
              class="pay-method cash col"
              :class="phoneNumberValid && clientNameValid ? '' : 'disabled'"
              :style="phoneNumberValid && clientNameValid ? '' : 'opacity: 0.5;'"
          >
            <div>
              <a
                  href=""
                  class="pay-cash next"
                  data-test-id="saveOrder"
                  @click.prevent="
                                    [
                                        openAvailableEmployeesModal(
                                            'safetyreceipt'
                                        ),
                                        hideOrderRecModal(),
                                        showThankYouModal()
                                    ]
                                "
              >
                <img
                    src="images/services/onwork/download.png"
                    alt=""
                />
                <h4 class="on-work-button-title">
                  Сохранная расписка
                </h4>
              </a>
            </div>
          </div>
          <!-- <div class="text-right w-100 px-3 mt-4"><a href="" class="remove-order">Удалить</a></div> -->
        </div>
      </div>
    </modal>
    <modal name="thankYouModal" width="700px" height="auto">
      <h5 class="modal-title p-4 d-inline-block">
        Спасибо большое, ждем Вас снова!
      </h5>
      <form
          action=""
          class=" d-flex align-items-center justify-content-center flex-wrap"
      >
        <div class="w-50 text-center">
          <img
              src="images/services/ready/end.png"
              class="my-4 w-100"
              alt=""
          />
        </div>

        <div class="code w-100 text-center">
          <button
              class="btn ml-auto on-work"
              @click="returnHome()"
              data-test-id="thankYouModalOk"
          >
            Ok
          </button>
        </div>
      </form>
    </modal>
    <sms-confirm
        ref="dlg"
        :order-id="order.id"
        code-type="order"
    />
    <qa-check
        :showQq="showQA"
        @close="showQA=false"
        @closeAndNext="saveQA($event)"
    />
    <Recommendations
        v-if="showRecommends"
        :show-recommendations="showRecommends"
        :rec-from-order = "recommendations"
        :recommendations-list="recommendationsList"
        :rec-cats="recCats"
        :init-rec-cats="initRecCats"
        @closeRec="showRecommends=false"
        @saveRec="saveRecs($event)"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import smsConfirm from '../smsComfirm.vue'
import Recommendations from "@/components/order/ChooseServices/recommendations.vue";

export default {
  name: 'ClientOrder',
  components: {
    Recommendations: Recommendations,
    smsConfirm: smsConfirm,
    chooseEmployeesModal: () => import("../../shift/ChooseEmployessModal.vue"),
    qaCheck: () => import("../../shift/qaCloseCheck.vue"),
    timeBar: () => import("./timeBar")
    // paymentModal: () => import("../../order/ChooseServices/PaymentModalNew")
  },
  data() {
    return {
      showRecommends: false,
      recommendations: null,
      recommendationsList: [],
      questionnaire: null,
      showQA: false,
      stateInProgress: false,
      storePhone: "",
      storeName: "",
      phoneNumber: [
        v => !!v || "необходимо заполнить",
        v => (v && v.length == 17) || "Введите все цифры номера"
      ],
      clientName: [v => !!v || "необходимо заполнить"],
      chosenServicesTitle: null,
      chosenServicesPrice: null,
      chosenServicesQuantity: null,
      chosenServicesEditIndex: "",
      addServiceDisabled: false,
      choosenEmployee: "",
      ruleQuantity: [
        v => !!v || "Необходимо заполнить",
        v => (v && v > 0) || "Значение должно быть больше нуля"
      ],
      rulePrice: [
        v => !!v || "Необходимо заполнить",
        v => (v && (v > 0 || v.length > 1)) || "Значение должно быть больше нуля"
      ]
    };
  },
  computed: {
    ...mapGetters([
      "client",
      "services",
      "chosenPromocode",
      "order",
      "chosenMark",
      "chosenModel",
      "runflat",
      "frameVehicle",
      "nextOrderStatus",
    ]),
    ...mapGetters('shift', [
      "shiftData",
      "employeesInShift",
      "autoAcquiring",
      "orderInfo",
    ]),
    phoneNumberValid() {
      return this.storePhone.length === 17;
    },
    wheelSide () {
      const outArr = []
      this.cart.services?.forEach((s, i) => {
        outArr[i] = s?.params?.content?.item?.side ?? null
      })
      return outArr
    },
    clientNameValid() {
      return this.storeName.length >= 2;
    },
    checkFilds() {
      return (
          this.chosenServices &&
          this.chosenServicesEditIndex &&
          this.chosenServicesPrice > 0 &&
          this.chosenServicesQuantity > 0
      )
    },
    chosenServices: {
      get() {
        return this.$store.getters.chosenServices;
      },
      set(value) {
        this.$store.commit("updateChosenServices", value);
      }
    },
    cart: {
      get() {
        return this.$store.getters.cart;
      },
      set(value) {
        this.$store.commit("updateCart", value);
      }
    },
    clientNameStore() {
      return this.client.customer.name
    },
    clientPhoneStore() {
      return this.client.customer.phone
    },
    availableDirections () {
      return this.$store.state.login.availableDirections
    },
    recCats () {
      const cat = {}
      console.log('cart', this.cart);
      if(this.cart && this.cart.services) {
        this.availableDirections.forEach((service)=>{
          if(service.serviceName) {
            cat[service.serviceName?.toLowerCase()]=1
          }
        })
        this.cart.services.forEach((service)=>{
          if(service.category_slug) {
            cat[service.category_slug?.toLowerCase()]=2
          }
        })
        return Object.keys(cat)
      } else {
        return []
      }
    },
    initRecCats () {
      let catSel = null
      console.log('cart', this.cart);
      if(this.cart && this.cart.services) {
        this.cart.services.forEach((service)=>{
          if(service.category_slug && !catSel) {
            catSel = this.recCats.findIndex(x => x.type == service.serviceName?.toLowerCase())
          }
        })
        return catSel.toString()
      } else {
        return null
      }
    },
    haveRecs () {
      let temp = {}
      let show = false
      if (this.recommendationsList) {
        this.recommendationsList.forEach((item) => {
          if (temp[item.type.toLowerCase()]) {
            temp[item.type.toLowerCase()].push(item);
          } else {
            temp[item.type.toLowerCase()] = []
            temp[item.type.toLowerCase()].push(item);
          }
        })
        Object.keys(temp).forEach(key => {
          if (this.recCats.includes(key)) show = true
        })
      }
      return show
    },
  },
  async mounted() {
    this.$store.commit("clearServices")
    this.$store.dispatch("getRecommendations").then((response) => {
      this.recommendationsList = response;
    })
    this.$store.dispatch("shift/fetchShiftData")
    this.storePhone = this.client.customer.phone
        ? this.client.customer.phone
        : "";
    this.storeName = this.client.customer.name
        ? this.client.customer.name
        : "";

    if (this.order?.status == 'ready') {
      this.checkTighten()
    }

    if (this.order.id) {
      this.$store
          .dispatch("fetchPricesWithCartItems", {
            cart: this.chosenServices,
            promocode: this.chosenPromocode,
            client: this.client
          })
          .finally(() => {
            this.questionnaire = this.order?.params?.questionnaire
            this.recommendations = this.order?.params?.recommendations
            this.$store.dispatch("updateOrder", {
              cart: this.cart,
              client: this.client,
              clientPhone: this.client.customer.phone ?? "",
              clientName: this.client.customer.name ?? "",
              promocode: this.chosenPromocode,
              shift: this.shiftData,
              status: this.order.status,
              order_id: this.order.id,
              mark: this.chosenMark ?? "",
              model: this.chosenModel ?? "",
              runflat: this.runflat,
              frameVehicle: this.frameVehicle,
              employee: this.choosenEmployee ?? "",
              questionnaire: this.questionnaire ?? "",
              recommendations: this.recommendations ?? ""
            });
            this.getOrderTime(this.order.id)
          });
    } else {
      this.$store.commit('shift/saveOrderInfo', {})
    }
  },
  watch: {
    clientNameStore(value) {
      this.storeName = value
    },
    clientPhoneStore(value) {
      this.storePhone = value
    },
    order() {
      this.addServiceDisabled =
          this.order.status == "ready" ||
          this.order.status == "paymentpending";
      if (this.order.id) {
        this.getOrderTime(this.order.id)
      }
    },
    client() {
      if (this.order.id) {
        this.$store
            .dispatch("fetchPricesWithCartItems", {
              cart: this.chosenServices,
              promocode: this.chosenPromocode,
              client: this.client
            })
            .finally(() => {
              this.$store.dispatch("updateOrder", {
                cart: this.cart,
                client: this.client,
                clientPhone: this.client.customer.phone ?? "",
                clientName: this.client.customer.name ?? "",
                promocode: this.chosenPromocode,
                shift: this.shiftData,
                status: this.order.status,
                order_id: this.order.id,
                mark: this.chosenMark ?? "",
                model: this.chosenModel ?? "",
                runflat: this.runflat,
                frameVehicle: this.frameVehicle,
                employee: this.choosenEmployee ?? "",
                questionnaire: this.questionnaire ?? "",
                recommendations: this.recommendations ?? ""
              });
              this.storeName = this.client.customer.name
            });
      }
    }
  },
  methods: {
    saveRecs (recs) {
      this.recommendations = recs
      this.showRecommends = false
      this.sendOrderToBackend('ready')
    },
    addRecommends () {
      console.log('showRec')
      this.showRecommends=true
    },
    checkOrderQA () {
      let haveWash = false
      this.cart.services.forEach((s)=>{
        if(s.category_slug == 'carwash') {
          haveWash = true
        }
      })
      if (haveWash && !this.questionnaire) {
        this.showQA = true
      } else {
        this.sendOrderToBackend('ready')
      }
    },
    saveQA(qa) {
      this.questionnaire = qa
      this.showQA = false
      this.sendOrderToBackend('ready')
    },
    getOrderTime (orderId) {
      const payload = { shiftId: this.shiftData.id ,orderId: orderId}
      this.$store.dispatch("shift/fetchOrder", payload).then((order) => {
        console.log('/order/fetchorder', order)
        this.questionnaire = order.params.questionnaire
        this.recommendations = order.params.recommendations
        this.$store.commit('shift/saveOrderInfo', order)
      })
    },
    getServiceType(service) {
      let type = '';
      let params = service?.params

      if (!params) return

      if (params.frameVehicle) {
        type = 'Рамный'
      }

      if (params.isRunflat) {
        if (type.length) {
          type += ' и Runflat'
        } else {
          type = 'Runflat'
        }
      }

      return type
    },
    loadServices(reasonId) {
      this.$store.dispatch("fetchServices", reasonId);
    },
    addServiceToCart(service) {
      this.$store.dispatch("addServiceToCart", {
        service: service,
        client: this.$store.getters.client
      });
    },
    sendOrderToBackend(status) {
      //temp
      //TODO: chose employee on safety receipt
      // if(status == 'safetyreceipt') {
      //     this.choosenEmployee = this.employeesInShift[0].employeeId
      // }
      //end temp
      console.log('AAAAAA', this.client)
      this.stateInProgress = true
      if (this.order.is_verified === false && this.order.id && status === 'paymentpending') {
        this.$store.dispatch('getSubmitSmsCode', {order_id: this.order.id}).then(() => {
          this.$refs.dlg.open({
            acceptText: 'Продолжить',
            cancelText: 'Отмена',
            dialogMaxWidth: 600,
          }).then(() => {
            this.updateOrder(status);
          }).catch((e) => {
            this.stateInProgress = false
            console.log('Error', e)
          })
        }).catch((e) => {
          this.stateInProgress = false
          console.log('Error', e)
        })
      } else if (this.order.id) {
        this.updateOrder(status);
      } else {
        this.$store.dispatch("postOrder", {
          cart: this.cart,
          client: this.client,
          clientPhone: this.storePhone,
          clientName: this.storeName,
          promocode: this.chosenPromocode,
          shift: this.shiftData,
          status: status,
          mark: this.chosenMark ?? "",
          model: this.chosenModel ?? "",
          runflat: this.runflat,
          frameVehicle: this.frameVehicle,
          employee: this.choosenEmployee ?? ""
        }).then((resp) => {
          this.changeQuery(resp.id)
          this.stateInProgress = false
        }).catch((e) => {
          console.log('Error:', e)
          this.stateInProgress = false
        });
      }
    },
    updateOrder(status = null) {
      this.$store.dispatch("updateOrder", {
        cart: this.cart,
        client: this.client,
        clientPhone: this.client.customer.phone ?? "",
        clientName: this.client.customer.name ?? "",
        promocode: this.chosenPromocode,
        shift: this.shiftData,
        status: status,
        order_id: this.order.id,
        mark: this.chosenMark ?? "",
        model: this.chosenModel ?? "",
        runflat: this.runflat,
        frameVehicle: this.frameVehicle,
        employee: this.choosenEmployee ?? "",
        questionnaire: this.questionnaire ?? "",
        recommendations: this.recommendations ?? ""
      }).then(() => {
        this.stateInProgress = false
      }).catch((e) => {
        console.log('Error:', e)
        this.stateInProgress = false
      });
    },
    rollbackOrderStatus() {
      this.$store.dispatch("prevOrderStatus", {
        order_id: this.order.id
      });
    },
    showOrderRecModal() {
      if (this.employeesInShift.length === 1) {
        this.$modal.show("orderRecModal");
      } else {
        // this.$modal.show('chooseEmployeesModal')
        this.$modal.show("orderRecModal");
      }
    },
    hideOrderRecModal() {
      this.$modal.hide("orderRecModal");
    },
    showThankYouModal() {
      this.$modal.show("thankYouModal");
    },
    hideThankYouModal() {
      this.$modal.hide("thankYouModal");
    },
    returnHome() {
      this.$router.push("/");
    },
    removeItemFromCart(index) {
      Promise.all([
        this.$store.commit("removeServiceFromCart", index),
        this.$store.dispatch("fetchPricesWithCartItems", {
          cart: this.chosenServices,
          promocode: this.chosenPromocode,
          client: this.client
        })
      ]).then(() => {
        this.chosenServicesEditIndex = "";
        this.updateOrder();
      });
    },
    removeAllItemFromCart() {
      Promise.all([
        this.$store.commit("removeAllServiceFromCart"),
        this.$store.dispatch("fetchPricesWithCartItems", {
          cart: this.chosenServices,
          promocode: this.chosenPromocode,
          client: this.client
        })
      ]).then(() => {
        this.chosenServicesEditIndex = "";
        this.updateOrder();
      });
    },
    editItemPrice(index) {
      this.chosenServicesEditIndex = index + 1;
      this.chosenServicesTitle = this.chosenServices[index].title;
      this.chosenServicesPrice = this.chosenServices[index].price;
      this.chosenServicesQuantity = this.chosenServices[index].quantity;
      if (this.chosenServices[index].manual_discount) {
        this.$modal.show("editPriceModal");
      }
    },
    closeEditItemPrice(service) {
      this.chosenServices[
      this.chosenServicesEditIndex - 1
          ].price = this.chosenServicesPrice;
      this.chosenServices[
      this.chosenServicesEditIndex - 1
          ].quantity = this.chosenServicesQuantity;
      this.$modal.hide("editPriceModal");
      this.$store.commit("addManualPriceFlag", service);
      this.$store.dispatch("fetchPricesWithCartItems", {
        cart: this.chosenServices,
        promocode: this.chosenPromocode,
        client: this.client
      });
    },
    numberWithSpaces(x) {
      return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : "";
    },
    changeQuery (orderId) {
      this.$router.replace({ query: { order: orderId } })
    },
    openAvailableEmployeesModal(status) {
      this.stateInProgress = true
      if (this.employeesInShift.length === 1) {
        this.choosenEmployee = this.employeesInShift[0].employeeId;
        this.sendOrderToBackend(status);
      } else {
        this.$store.commit("updateNextOrderStatus", status);
        this.$modal.show("chooseEmployeesModal");
        this.stateInProgress = false
      }
    },
    onEmployeeChoosed(value) {
      this.choosenEmployee = value;
      this.$modal.hide("chooseEmployeesModal");
      this.sendOrderToBackend(this.nextOrderStatus);
    },
    checkTighten() {
      if (
          this.chosenServices.filter(service => {
            return service.need_tighten === 1;
          }).length > 0
      ) {
        this.$modal.show("tightenModal");
      }
    },
    showPaymentModal() {
      if (this.client?.discount.value > 0.24 && !this.order.id) {
        this.$store.dispatch('getSubmitSmsCode', {order_id: this.order.id}).then(() => {
          this.$refs.dlg.open({
            acceptText: 'Продолжить',
            cancelText: 'Отмена',
            dialogMaxWidth: 600,
          }).then(() => {
            this.$store.dispatch('setPaymentModal', true)
          }).catch((e) => {
            this.stateInProgress = false
            console.log('Error', e)
          })
        }).catch((e) => {
          this.stateInProgress = false
          console.log('Error', e)
        })
      }
    },
    showOrderInfo() {
      return this.order.id
          ? "№" + this.order.id + " (" + this.order.displayStatus + ")"
          : "";
    }
  }
};
</script>
<style scoped>
  .disabled {
    pointer-events: none;
  }
  .order-body {
    margin-top: 15px;
  }
.client-order.sticky-top {
  z-index: 99;
}

.header-inprogress {
  background-color: #f5a623;
}

.header-ready {
  background-color: #b5e97c;
}

.header-paymentpending {
  background-color: #c5ee99;
}
</style>
